import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { getEmployee } from "../../apis/employee/employee";
import { viewLoading } from "../../utils/loading";
import { apiError, getEmployeeAlarmSettingSuccess, getEmployeeDetailSuccess, getEmployeeExternalProfileSuccess, getEmployeeSuccess } from "./actions";
import { SET_EMPLOYEE_ALARM_SETTING, SET_EMPLOYEE_DETAIL, SET_EMPLOYEE_EXTERNAL_PROFILE, SET_PREVIEW_EMPLOYEE } from "./actionTypes";
import { getExternalProfileWithEmployee } from "../../apis/externalProfile";
import { getPushNotiStates } from "../../apis/notification";


function* getPreviewEmploayee({ payload }) {
  if (payload.employee) {
    viewLoading(true);
    try {
      const response = yield call(getEmployee, payload.employee, payload?.params);
      yield put(getEmployeeSuccess({ ...response, isTax: payload?.params?.isTax || false }));
    } catch (error) {
      yield put(apiError(error));
    }
    viewLoading(false);
  } else {
    yield put(getEmployeeSuccess(null));
  }
}

function* getEmployeeDetail({ payload }) {

  const { employeeIdx, options } = payload;

  if (employeeIdx) {
    viewLoading(true);
    try {
      const response = yield call(getEmployee, employeeIdx, options);
      yield put(getEmployeeDetailSuccess({ ...response, options }));
    } catch (error) {
      yield put(apiError(error));
    }
    viewLoading(false);
  } else {
    yield put(getEmployeeDetailSuccess(null));
  }
}

function* getEmployeeExternalProfile({ payload }) {
  const { employee } = payload;
  if (employee) {
    const response = yield call(getExternalProfileWithEmployee, employee);
    yield put(getEmployeeExternalProfileSuccess({ ...response }));
  } else {
    yield put(getEmployeeExternalProfileSuccess(null));
  }
}

function* getEmployeeAlarmSetting({ payload }) {
  const { employee } = payload;
  if (employee) {
    const response = yield call(getPushNotiStates, employee);
    yield put(getEmployeeAlarmSettingSuccess(response));
  } else {
    yield put(getEmployeeAlarmSettingSuccess(null));
  }
}

function* watchGetPreviewEmploayee() {
  yield takeEvery(SET_PREVIEW_EMPLOYEE, getPreviewEmploayee);
}
function* watchGetEmployeeDetail() {
  yield takeEvery(SET_EMPLOYEE_DETAIL, getEmployeeDetail);
}
function* watchGetEmployeeExternalProfile() {
  yield takeEvery(SET_EMPLOYEE_EXTERNAL_PROFILE, getEmployeeExternalProfile);
}
function* watchGetEmployeeAlarmSetting() {
  yield takeEvery(SET_EMPLOYEE_ALARM_SETTING, getEmployeeAlarmSetting);
}

function* SerachPersonSaga() {
  yield all([
    fork(watchGetPreviewEmploayee),
    fork(watchGetEmployeeDetail),
    fork(watchGetEmployeeExternalProfile),
    fork(watchGetEmployeeAlarmSetting),
  ]);
}

export default SerachPersonSaga;
